// M127 — pure resolver voor de OUTER `ConnectorCard`-badge op /privacy.
//
// Geëxtraheerd naar een eigen module zodat de unit-test (`craco test`)
// het kan importeren zonder de `@/`-alias uit `PrivacyVaultPage.jsx` te
// hoeven resolven (Jest kent die alias niet in deze CRA/CRACO-opzet).
//
// Contract:
//   resolveConnectorBadge(connector, gSvc) → { verified, label, testid }
//
// - Voor Google-bronnen (google_ads/ga4/gsc): kijk EERST naar de centrale
//   bron `services.<svc>.state`. Bij `verified` → "Verbonden met
//   {account_name}" (voor GSC zet de backend hier de site-URL in).
//   Andere states → gebruik `last_status_nl` / `state_nl` (B1-outcome).
// - Voor niet-Google-bronnen: val terug op `connector.connected` uit
//   `/api/privacy/vault` (`db.sources.connected`), zoals vóór M127.
//
// Deze mapping is de enige plek die "Niet gekoppeld" mag emitteren voor
// Google-bronnen — en alleen wanneer state != "verified".

export const GSVC_KEY = { google_ads: "ads", ga4: "ga4", gsc: "gsc" };

export function resolveConnectorBadge(connector, gSvc, labels = {}) {
  const connectedFallback = labels.connected || "Gekoppeld";
  const notConnectedFallback = labels.not_connected || "Niet gekoppeld";
  const svcKey = GSVC_KEY[connector.key];
  const svc = svcKey && gSvc ? gSvc[svcKey] : null;
  if (svc) {
    if (svc.state === "verified") {
      const label = svc.account_name
        ? `Verbonden met ${svc.account_name}`
        : "Verbonden";
      return { verified: true, label, testid: "outer-badge-verified" };
    }
    const label = svc.last_status_nl || svc.state_nl || "Nog niet gekoppeld";
    return { verified: false, label, testid: "outer-badge-not-verified" };
  }
  return connector.connected
    ? { verified: true, label: connectedFallback,
        testid: "outer-badge-verified" }
    : { verified: false, label: notConnectedFallback,
        testid: "outer-badge-not-verified" };
}
